export default __webpack_public_path__ + "static/media/homelogo.cee5bc4b.svg";